import styled from 'styled-components';

export const SlideWrapper = styled.div`
  width: 100%;
  height: 322px;
  background: #f5714b;
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  & .slide-img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    overflow: hidden;
  }

  & .slide-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
  }

  & .slide-name {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
  }

  & .slide-position {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;
  }
`;
